<template>
    <div class="enterprise-detail">
        <div class="mb-160">
            <img class="enterprise-detail__img" :src="item.src" alt="">
            <p class="enterprise-detail__text">{{ item.text }}</p>
            <a class="enterprise-detail__link" :href="item.url">{{ item.name }}</a>
        </div>

        <div class="enterprise-detail__products ">
            <h2>Продукция</h2>
            <div class="enterprise-detail__products-list">
                <div class="enterprise-detail__products-item position-relative" v-for="(product, id) in item.products"
                     :key="id">
                    <img class="enterprise-detail__products-img" :src="product.src" :alt="product.name">
                    <h3 class="enterprise-detail__products-name">{{ product.name }}</h3>
                    <a class="enterprise-detail__products-link" :href="product.url"></a>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: "enterpriseDetail",
    props: {
      element: Array | String | Number | Boolean | Object,
    },
    data() {
        return {
          item: this.element,
            /*item: {
                text: 'ООО «Оргсинтез ПроЛаб» является современным заводом по производству акриловых дисперсий в РФ. В основу данного предприятия заложены новейшие принципы производства полимерных дисперсий, базирующиеся на приверженности постоянства качества, высокой технологичности и экологической безопасности.',
                src: '/upload/history.jpg',
                name: 'Ссылка',
                url: '',
                products: [
                    {
                        src: '/upload/product.svg',
                        name: 'Продукт 1',
                        url: ''
                    },
                    {
                        src: '/upload/product.svg',
                        name: 'Продукт 2',
                        url: ''
                    },
                    {
                        src: '/upload/product.svg',
                        name: 'Продукт 3',
                        url: ''
                    },
                    {
                        src: '/upload/product.svg',
                        name: 'Продукт 4',
                        url: ''
                    },
                ]

            }*/
        }
    }
}
</script>

<style scoped lang="scss">
.enterprise-detail {
  position: relative;

  &__text {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 32px;
    line-height: 100%;
    letter-spacing: 0px;
    vertical-align: middle;
    max-width: 1180px;
    width: 100%;
    color: #212424;
  }

  &__img {
    position: absolute;
    top: -220px;
    right: 0;
    width: 402px;
    height: 269px;
    border-radius: 20px;
    object-fit: cover;

    @media (max-width: 1650px) {
      position: unset;
      margin-bottom: 30px;
      display: block;
    }
  }

  &__link {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 600;
    font-size: 20px;
    line-height: 20px;
    letter-spacing: -0.02px;
    vertical-align: middle;
    color: #FA4237;
    margin-top: 64px;
    display: block;
  }

  &__products {
    & h2 {
      font-family: 'MuseoSansCyrl-500';
      font-weight: 400;
      font-size: 72px;
      line-height: 72px;
      letter-spacing: 0px;
      color: #212424;
      margin-bottom: 60px;
    }


  }

  &__products-list {
    max-width: 1840px;
    width: 100%;
    position: relative;

  }

  &__products-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 24px 32px;
    border-radius: 36px;
    background: #F5F5F7;
    margin-right: 8px;

    &:last-of-type {
      margin: 0;
    }
  }

  &__products-img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: block;
    margin-bottom: 152px;
  }

  &__products-link {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

}
</style>

<style lang="scss">
.enterprise-detail__products-list {

  & .slick-arrow {
    position: absolute;
    top: -85px;
    right: 0;
    width: 56px;
    height: 56px;
    border-radius: 12px;
    border: 1px solid #E1E1E2;
    background: url("/local/templates/international/img/fi_chevron-down.svg") no-repeat center;
    display: flex;
    align-items: center;
    justify-content: center;

  }

  & .slick-arrow:hover,
  & .slick-arrow:focus {
    opacity: 0.8 !important;
    background: url("/local/templates/international/img/fi_chevron-down.svg") no-repeat center !important;
  }

  & .slick-prev {
    left: unset;
    right: 70px;
    transform: rotate(180deg) translateY(27px);
  }


}

</style>